import { Component, effect, inject, OnInit, ViewChild } from '@angular/core';

import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { NavBarComponent } from '@shared/components/organisms/nav-bar/nav-bar.component';
import { FooterComponent } from '@shared/components/organisms/footer/footer.component';
import { UserStore } from '@shared/stores/user.store';
import { enableMapSet } from 'immer';
import { filter } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { UserInactivityService } from '@shared/services/user-inactivity.service';
import { InactivityWarningOrchestratorService } from '@shared/services/inactivity-warning-orchestrator.service';
import { CommonFunctionsService } from '@shared/services/common-functions.service';
import { DownloadJobsStore } from '@shared/stores/download-jobs.store';
import { DownloadsPanelComponent } from '@shared/components/organisms/downloads-panel/downloads-panel.component';

enableMapSet();

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    MatSidenavModule,
    NavBarComponent,
    FooterComponent,
    DownloadsPanelComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Publication';
  dialogRef: MatDialogRef<any, any>;

  @ViewChild('drawer') drawer!: MatDrawer;
  private readonly userStore = inject(UserStore);
  private readonly commonFunctionsService = inject(CommonFunctionsService);
  private readonly downloadJobsStore = inject(DownloadJobsStore);


  constructor(
    private translate: TranslateService,
    private userInactivityService: UserInactivityService,
    private orchestrator: InactivityWarningOrchestratorService,
    protected router: Router,
  ) {
    this.userStore.initAuth();
    this.translate.addLangs(['en', 'fr', 'es']);
    this.translate.setDefaultLang('en');
    this.translate.use(this.translate.getBrowserLang() || 'en');
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      document.querySelector('.root-container')?.scrollTo({ top: 0 });
    });

    effect(() => {
      const user = this.userStore.user();
      const currentRoute = this.commonFunctionsService.currentRoute$();

      if (user.userId && currentRoute !== '') {
        const allowedExpiredBaseRoutes = [
          '/profile/company-settings',
          '/profile/user-profile',
          '/purchase'
        ];

        if (allowedExpiredBaseRoutes.some(x => currentRoute.includes(x))) {
          this.downloadJobsStore.initialize();
          return;
        }
      }

      if (user.userId) {
        this.userInactivityService.startMonitoring();
        this.orchestrator.start();
        this.downloadJobsStore.initialize();
      } else {
        this.downloadJobsStore.reset();
      }
    });
  }

  ngOnInit() {
    const setViewportHeightVar = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    window.addEventListener('resize', setViewportHeightVar);
    setViewportHeightVar();

    this.commonFunctionsService.initializeRouteTracking();
  }

  toggleDrawer() {
    this.drawer.toggle();
  }


}
